module.exports = __webpack_public_path__ + "img/MES6Indice3.adace432.png";